package org.zq.astrock_ai.ui.research.gushi.data

import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.zq.astrock_ai.storage.ResearchKvStorage
import kotlin.random.Random

@Serializable
data class DeviceLicenseSession(
    val deviceId: String,
    val token: String = "",
    val plan: String = "",
    val planLabel: String = "",
    val expiresAtMs: Long = 0L,
    val expiresAtLabel: String = "",
)

object DeviceLicenseStore {
    private const val DEVICE_KEY = "license.deviceId.v1"
    private const val SESSION_KEY = "license.session.v1"
    private val json = Json { ignoreUnknownKeys = true }
    private val alphabet = "abcdef0123456789"

    fun deviceId(): String {
        val existing = ResearchKvStorage.get(DEVICE_KEY)?.trim().orEmpty()
        if (existing.length >= 16) return existing
        val created = buildString {
            repeat(32) { append(alphabet[Random.nextInt(alphabet.length)]) }
        }
        ResearchKvStorage.put(DEVICE_KEY, created)
        return created
    }

    fun load(): DeviceLicenseSession? {
        val raw = ResearchKvStorage.get(SESSION_KEY)?.trim().orEmpty()
        if (raw.isBlank()) return null
        return runCatching { json.decodeFromString<DeviceLicenseSession>(raw) }.getOrNull()
            ?.takeIf { it.token.isNotBlank() }
    }

    fun save(
        token: String,
        plan: String,
        planLabel: String,
        expiresAtMs: Long,
        expiresAtLabel: String,
    ) {
        val session = DeviceLicenseSession(
            deviceId = deviceId(),
            token = token,
            plan = plan,
            planLabel = planLabel,
            expiresAtMs = expiresAtMs,
            expiresAtLabel = expiresAtLabel,
        )
        ResearchKvStorage.put(SESSION_KEY, json.encodeToString(session))
    }

    fun clearToken() {
        val id = deviceId()
        ResearchKvStorage.put(SESSION_KEY, json.encodeToString(DeviceLicenseSession(deviceId = id)))
    }
}
